// react-query-client.ts
import { QueryClient } from "@tanstack/react-query";
import { queryCache, mutationCache } from "./utils/errorHandler";


export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});
